export const NOT_FOUND_LOTTERY_ID = 'NOT FOUND LOTTERY ID'
